<template>
  <el-dialog
    v-if="visible"
    show-close
    :visible="visible"
    width="500px"
    :title="'选择出运明细模版'"
    :close-on-click-modal="false"
    :before-close="() => close()"
    :modal-append-to-body="false"
    :modal="false"
    v-el-dialog-drag
  >
    <div class="print_btn_group">
      <el-button plain @click="exportExcel('orderBatchNo')">
        {{ '按柜导出' }}
      </el-button>
      <el-button plain @click="exportExcel('retailerPo')">
        {{ '按PO导出' }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    visible: { type: Boolean, default: false },
    shipmentCode: { type: String, default: '' },
  },
  methods: {
    close() {
      this.$emit('close')
      this.$emit('update:visible', false)
    },
    async exportExcel(type) {
      const parms = { shipmentCode: this.shipmentCode }
      this.loadingOpen()
      const checkRes = await this.$api
        .shipmentInfoShipmentBatchDetailsCheckDataApi(parms)
        .catch(() => null)
      const { status, msg } = checkRes || {}
      if (status != 200) {
        this.loadingClose()
        this.$message.error(msg)
        return
      }

      const context = { ...parms, type }
      const exportRes = await this.$api
        .SYS_EXPORT_TASK('factory-shipment-batch-details', context)
        .catch(() => null)
      this.loadingClose()
      const { status: exportStatus } = exportRes || {}
      if (exportStatus !== 200) {
        this.$message.error(
          this.$l('INDEX.Description_Failed_to_add_export_task') ||
            '导出任务添加失败'
        )
        return
      }
      this.$message({
        message:
          this.$l('INDEX.added_to_the_download_center') ||
          '导出任务已经添加到下载中心，请稍后从下载中心下载文件',
        type: 'success',
      })
      this.close()
    },
  },
}
</script>
<style lang="scss" scoped>
.print_btn_group {
  height: 110px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
</style>
